<form [formGroup]="captacao">
  <div class="row">
    <div class="col-sm d-flex justify-content-start">
      <h3 class="mt-3">Coleta</h3>
    </div>
    <div class="col-sm d-flex justify-content-end">
      <button
        *ngIf="!termoValido; else textoFinalizado"
        style="margin: 10px"
        type="button"
        mat-flat-button
        color="warn"
        (click)="finalizarColeta()"
        [disabled]="!finalizarEdColeta || !desabilitarBotoes"
      >
        <span>Finalizar Coleta</span>
      </button>
      <ng-template #textoFinalizado>
        <div
          style="
            text-align: right;
            color: red;
            font-style: italic;
            margin-top: 1.3em;
            margin-right: 1em;
          "
        >
          *Formulário da coleta finalizado
        </div></ng-template
      >
    </div>
  </div>
  <p style="font-size: small">
    <i>Os campos marcados em vermelho são de preenchimento obrigatório.</i>
  </p>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Local da Coleta</mat-label>
        <mat-select formControlName="localCaptacao">
          <mat-option value="Centro cirúrgico">Centro Cirúrgico</mat-option>
          <mat-option value="Outro">Outro</mat-option>
          <mat-option value="Consultorio">Consultório</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Outro Local</mat-label>
        <input
          matInput
          placeholder="Descrição local da coleta"
          formControlName="descricaoLocalColeta"
          id="descricaoLocalColeta"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Transportadora</mat-label>
        <input
          matInput
          placeholder="Transportadora"
          formControlName="transportadora"
          id="transportadora"
        />
      </mat-form-field>
    </div>
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Data da Coleta</mat-label>
        <input
          matInput
          rInputMask="99/99/9999"
          placeholder="dd/mm/aaaa"
          formControlName="dataColeta"
        />
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Início do Procedimento (Horário)</mat-label>
        <input
          matInput
          placeholder="Início do Procedimento"
          formControlName="inicioProcedimento"
          id="inicioProcedimento"
          mask="00:00"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Fim do Procedimento (Horário)</mat-label>
        <input
          matInput
          placeholder="Fim do Procedimento"
          formControlName="fimProcedimento"
          id="fimProcedimento"
          mask="00:00"
        />
      </mat-form-field>
    </div>
  </div>

  <!-- <div class="row">
        <div class="col-6">
            <mat-form-field appearance="standard" class="input-full-width">
                <mat-label>Data do Recebimento CPC</mat-label>
                <input matInput rInputMask="99/99/9999" placeholder="dd/mm/aaaa"  formControlName="dataRecebimentoCPC">
            </mat-form-field>
            </div>


    </div> -->
  <div class="row mt-4">
    <div class="col-3">
      <mat-label
        [ngClass]="
          captacao.get('bochechos').hasError('required') ? 'error' : 'ok'
        "
        >Realizou bochechos?</mat-label
      ><br />
      <mat-radio-group
        formControlName="bochechos"
        (change)="resetField('clorexidina')"
        (change)="resetField('clorexidinaPorcentagem')"
        (change)="resetField('perboratoDeSodioBlueM')"
        (change)="resetField('perboratoSodioPorcentagem')"
        (change)="resetField('peroxidoDeHidrogenio')"
        (change)="resetField('peroxidoHidrogenioPorcentagem')"
        (change)="resetField('cetilperidinio')"
        (change)="resetField('cetilperidinioPorcentagem')"
        (change)="resetField('outrosBochechoCheck')"
        (change)="resetField('outroBochechos')"
        (change)="resetField('outroBochechoPorcentagem')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>
    </div>

    <div *ngIf="captacao.value.bochechos == 'sim'" class="col-9">
      <div class="row">
        <div class="col-3">
          <mat-checkbox
            formControlName="clorexidina"
            (change)="resetField('clorexidinaPorcentagem')"
            [disabled]="termoValido"
            >Clorexidina</mat-checkbox
          >
          <mat-form-field
            *ngIf="captacao.value.clorexidina"
            appearance="standard"
            class="input-full-width"
          >
            <mat-label>Porcentagem</mat-label>
            <input
              matInput
              placeholder="Qual"
              formControlName="clorexidinaPorcentagem"
              id="clorexidinaPorcentagem"
              mask="separator.2"
              thousandSeparator="."
              suffix="%"
            />
          </mat-form-field>
        </div>

        <div class="col-5">
          <mat-checkbox
            formControlName="perboratoDeSodioBlueM"
            (change)="resetField('perboratoSodioPorcentagem')"
            [disabled]="termoValido"
            >Perborato de Sódio (BlueM)</mat-checkbox
          >
          <mat-form-field
            *ngIf="captacao.value.perboratoDeSodioBlueM"
            appearance="standard"
            class="input-full-width"
          >
            <mat-label
              >Porcentagem
              {{ captacao.get("perboratoSodioPorcentagem").value }}</mat-label
            >
            <input
              matInput
              placeholder="Qual"
              formControlName="perboratoSodioPorcentagem"
              id="perboratoSodioPorcentagem"
              mask="separator.2"
              thousandSeparator="."
              suffix="%"
            />
          </mat-form-field>
        </div>

        <div class="col-4">
          <mat-checkbox
            formControlName="peroxidoDeHidrogenio"
            (change)="resetField('peroxidoHidrogenioPorcentagem')"
            [disabled]="termoValido"
            >Peróxido de hidrogênio</mat-checkbox
          >
          <mat-form-field
            *ngIf="captacao.value.peroxidoDeHidrogenio"
            appearance="standard"
            class="input-full-width"
          >
            <mat-label>Porcentagem</mat-label>
            <input
              matInput
              placeholder="Qual"
              formControlName="peroxidoHidrogenioPorcentagem"
              id="peroxidoHidrogenioPorcentagem"
              mask="separator.2"
              thousandSeparator="."
              suffix="%"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-3">
          <mat-checkbox
            formControlName="cetilperidinio"
            (change)="resetField('cetilperidinioPorcentagem')"
            [disabled]="termoValido"
            >Cetilperidínio</mat-checkbox
          >
          <mat-form-field
            *ngIf="captacao.value.cetilperidinio"
            appearance="standard"
            class="input-full-width"
          >
            <mat-label>Porcentagem</mat-label>
            <input
              matInput
              placeholder="Qual"
              formControlName="cetilperidinioPorcentagem"
              id="cetilperidinioPorcentagem"
              mask="separator.2"
              thousandSeparator="."
              suffix="%"
            />
          </mat-form-field>
        </div>

        <div class="col-9">
          <mat-checkbox
            formControlName="outrosBochechoCheck"
            (change)="resetField('outroBochechos')"
            (change)="resetField('outroBochechoPorcentagem')"
            [disabled]="termoValido"
            >Outros</mat-checkbox
          ><br />

          <div class="row">
            <div class="col-6">
              <mat-form-field
                *ngIf="captacao.value.outrosBochechoCheck"
                appearance="standard"
                class="input-full-width"
              >
                <mat-label>Qual?</mat-label>
                <input
                  matInput
                  placeholder="Qual"
                  formControlName="outroBochechos"
                  id="outroBochechos"
                />
              </mat-form-field>
            </div>

            <div class="col-6">
              <mat-form-field
                *ngIf="captacao.value.outrosBochechoCheck"
                appearance="standard"
                class="input-full-width"
              >
                <mat-label>Porcentagem</mat-label>
                <input
                  matInput
                  placeholder="Qual"
                  formControlName="outroBochechoPorcentagem"
                  id="outroBochechoPorcentagem"
                  mask="separator.2"
                  thousandSeparator="."
                  suffix="%"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-3">
      <mat-label
        [ngClass]="
          captacao.get('profilaxia').hasError('required') ? 'error' : 'ok'
        "
        >Realizou Profilaxia?</mat-label
      ><br />
      <mat-radio-group
        formControlName="profilaxia"
        (change)="resetField('pedraPomes')"
        (change)="resetField('pastaPolifatica')"
        (change)="resetField('outroProfilaxiaCheck')"
        (change)="resetField('outroProfilaxia')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>
    </div>

    <div *ngIf="captacao.value.profilaxia == 'sim'" class="col-9">
      <div class="row">
        <div class="col-3">
          <mat-checkbox formControlName="pedraPomes" [disabled]="termoValido"
            >Pedra Pomes</mat-checkbox
          >
        </div>

        <div class="col-3">
          <mat-checkbox
            formControlName="pastaPolifatica"
            [disabled]="termoValido"
            >Pasta Profilática</mat-checkbox
          >
        </div>

        <div class="col-6">
          <mat-checkbox
            formControlName="outroProfilaxiaCheck"
            (change)="resetField('outroProfilaxia')"
            [disabled]="termoValido"
            >Outro</mat-checkbox
          >

          <mat-form-field
            *ngIf="captacao.value.outroProfilaxiaCheck"
            appearance="standard"
            class="input-full-width"
          >
            <mat-label>Qual?</mat-label>
            <input
              matInput
              placeholder="Qual"
              formControlName="outroProfilaxia"
              id="outroProfilaxia"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-3">
      <mat-label
        [ngClass]="
          captacao.get('anestesicoTopico').hasError('required') ? 'error' : 'ok'
        "
        >Usou anestésico tópico?</mat-label
      ><br />
      <mat-radio-group
        formControlName="anestesicoTopico"
        (change)="resetField('benzocaina')"
        (change)="resetField('benzocainaPorcentagem')"
        (change)="resetField('tetracaina')"
        (change)="resetField('tetracainaPorcentagem')"
        (change)="resetField('xilocaina')"
        (change)="resetField('xilocainaPorcentagem')"
        (change)="resetField('outrosAnestesicoTopicoCheck')"
        (change)="resetField('outroAnestesicoTopico')"
        (change)="resetField('outroAnestesicoTPorcentagem')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>
    </div>

    <div *ngIf="captacao.value.anestesicoTopico == 'sim'" class="col-9">
      <div class="row">
        <div class="col-4">
          <mat-checkbox
            formControlName="benzocaina"
            (change)="resetField('benzocainaPorcentagem')"
            [disabled]="termoValido"
            >Benzocaína</mat-checkbox
          >
          <mat-form-field
            *ngIf="captacao.value.benzocaina"
            appearance="standard"
            class="input-full-width"
          >
            <mat-label>Porcentagem</mat-label>
            <input
              matInput
              placeholder="Qual"
              formControlName="benzocainaPorcentagem"
              id="benzocainaPorcentagem"
              mask="separator.2"
              thousandSeparator="."
              suffix="%"
            />
          </mat-form-field>
        </div>

        <div class="col-4">
          <mat-checkbox
            formControlName="tetracaina"
            (change)="resetField('tetracainaPorcentagem')"
            [disabled]="termoValido"
            >Tetracaína</mat-checkbox
          >
          <mat-form-field
            *ngIf="captacao.value.tetracaina"
            appearance="standard"
            class="input-full-width"
          >
            <mat-label>Porcentagem</mat-label>
            <input
              matInput
              placeholder="Qual"
              formControlName="tetracainaPorcentagem"
              id="tetracainaPorcentagem"
              mask="separator.2"
              thousandSeparator="."
              suffix="%"
            />
          </mat-form-field>
        </div>

        <div class="col-4">
          <mat-checkbox
            formControlName="xilocaina"
            (change)="resetField('xilocainaPorcentagem')"
            [disabled]="termoValido"
            >Xilocaína</mat-checkbox
          >
          <mat-form-field
            *ngIf="captacao.value.xilocaina"
            appearance="standard"
            class="input-full-width"
          >
            <mat-label>Porcentagem</mat-label>
            <input
              matInput
              placeholder="Qual"
              formControlName="xilocainaPorcentagem"
              id=" xilocainaPorcentagem"
              mask="separator.2"
              thousandSeparator="."
              suffix="%"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <mat-checkbox
            formControlName="outrosAnestesicoTopicoCheck"
            (change)="resetField('outroAnestesicoTopico')"
            [disabled]="termoValido"
            >Outros</mat-checkbox
          >

          <div class="row">
            <div class="col-8">
              <mat-form-field
                *ngIf="captacao.value.outrosAnestesicoTopicoCheck"
                appearance="standard"
                class="input-full-width"
              >
                <mat-label>Qual?</mat-label>
                <input
                  matInput
                  placeholder="Qual"
                  formControlName="outroAnestesicoTopico"
                  id="outroAnestesicoTopico"
                />
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field
                *ngIf="captacao.value.outrosAnestesicoTopicoCheck"
                appearance="standard"
                class="input-full-width"
              >
                <mat-label>Porcentagem</mat-label>
                <input
                  matInput
                  placeholder="Qual"
                  formControlName="outroAnestesicoTPorcentagem"
                  id=" outroAnestesicoTPorcentagem"
                  mask="separator.2"
                  thousandSeparator="."
                  suffix="%"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-3">
      <mat-label
        [ngClass]="
          captacao.get('anestesicoInjetavel').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Usou anestésico injetável?</mat-label
      ><br />
      <mat-radio-group
        formControlName="anestesicoInjetavel"
        (change)="resetField('mepivacainaPorcentagem')"
        (change)="resetField('mepivacaina')"
        (change)="resetField('prilocaina')"
        (change)="resetField('prilocainaPorcentagem')"
        (change)="resetField('articaina')"
        (change)="resetField('articainaPorcentagem')"
        (change)="resetField('citocaina')"
        (change)="resetField('citocainaPorcentagem')"
        (change)="resetField('lidocaina')"
        (change)="resetField('lidocainaPorcentagem')"
        (change)="resetField('outrosAnestesicoInjetavelCheck')"
        (change)="resetField('outroAnestesicoInjetavel')"
        (change)="resetField('outroAnestesicoIPorcentagem')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-9" *ngIf="captacao.value.anestesicoInjetavel == 'sim'">
      <div class="row">
        <div class="col-4">
          <mat-checkbox
            formControlName="mepivacaina"
            (change)="resetField('mepivacainaPorcentagem')"
            [disabled]="termoValido"
            >Mepivacaína</mat-checkbox
          >
          <mat-form-field
            *ngIf="captacao.value.mepivacaina"
            appearance="standard"
            class="input-full-width"
          >
            <mat-label>Porcentagem</mat-label>
            <input
              matInput
              placeholder="Qual"
              formControlName="mepivacainaPorcentagem"
              id=" mepivacainaPorcentagem"
              mask="separator.2"
              thousandSeparator="."
              suffix="%"
            />
          </mat-form-field>
        </div>

        <div class="col-4">
          <mat-checkbox
            formControlName="prilocaina"
            (change)="resetField('prilocainaPorcentagem')"
            [disabled]="termoValido"
            >Prilocaína</mat-checkbox
          >
          <mat-form-field
            *ngIf="captacao.value.prilocaina"
            appearance="standard"
            class="input-full-width"
          >
            <mat-label>Porcentagem</mat-label>
            <input
              matInput
              placeholder="Qual"
              formControlName="prilocainaPorcentagem"
              id=" prilocainaPorcentagem"
              mask="separator.2"
              thousandSeparator="."
              suffix="%"
            />
          </mat-form-field>
        </div>

        <div class="col-4">
          <mat-checkbox
            formControlName="articaina"
            (change)="resetField('articainaPorcentagem')"
            [disabled]="termoValido"
            >Articaína</mat-checkbox
          >
          <mat-form-field
            *ngIf="captacao.value.articaina"
            appearance="standard"
            class="input-full-width"
          >
            <mat-label>Porcentagem</mat-label>
            <input
              matInput
              placeholder="Qual"
              formControlName="articainaPorcentagem"
              id="articainaPorcentagem"
              mask="separator.2"
              thousandSeparator="."
              suffix="%"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-3">
          <mat-checkbox
            formControlName="citocaina"
            (change)="resetField('citocainaPorcentagem')"
            [disabled]="termoValido"
            >Citocaína</mat-checkbox
          >
          <mat-form-field
            *ngIf="captacao.value.citocaina"
            appearance="standard"
            class="input-full-width"
          >
            <mat-label>Porcentagem</mat-label>
            <input
              matInput
              placeholder="Qual"
              formControlName="citocainaPorcentagem"
              id="citocainaPorcentagem"
              mask="separator.2"
              thousandSeparator="."
              suffix="%"
            />
          </mat-form-field>
        </div>

        <div class="col-3">
          <mat-checkbox
            formControlName="lidocaina"
            (change)="resetField('lidocainaPorcentagem')"
            [disabled]="termoValido"
            >Lidocaína</mat-checkbox
          >
          <mat-form-field
            *ngIf="captacao.value.lidocaina"
            appearance="standard"
            class="input-full-width"
          >
            <mat-label>Porcentagem</mat-label>
            <input
              matInput
              placeholder="Qual"
              formControlName="lidocainaPorcentagem"
              id="lidocainaPorcentagem"
              mask="separator.2"
              thousandSeparator="."
              suffix="%"
            />
          </mat-form-field>
        </div>

        <div class="col-6">
          <mat-checkbox
            formControlName="outrosAnestesicoInjetavelCheck"
            (change)="resetField('outroAnestesicoInjetavel')"
            (change)="resetField('outroAnestesicoIPorcentagem')"
            [disabled]="termoValido"
            >Outros</mat-checkbox
          >

          <div class="row">
            <div class="col-8">
              <mat-form-field
                *ngIf="captacao.value.outrosAnestesicoInjetavelCheck"
                appearance="standard"
                class="input-full-width"
              >
                <mat-label>Qual?</mat-label>
                <input
                  matInput
                  placeholder="Qual"
                  formControlName="outroAnestesicoInjetavel"
                  id="outroAnestesicoInjetavel"
                />
              </mat-form-field>
            </div>

            <div class="col-4">
              <mat-form-field
                *ngIf="captacao.value.outrosAnestesicoInjetavelCheck"
                appearance="standard"
                class="input-full-width"
              >
                <mat-label>Porcentagem</mat-label>
                <input
                  matInput
                  placeholder="Qual"
                  formControlName="outroAnestesicoIPorcentagem"
                  id="outroAnestesicoIPorcentagem"
                  mask="separator.2"
                  thousandSeparator="."
                  suffix="%"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-3">
      <mat-label
        [ngClass]="
          captacao.get('anestesicoVasoConstritor').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Anestésico com vaso constritor?</mat-label
      ><br />
      <mat-radio-group
        formControlName="anestesicoVasoConstritor"
        (change)="resetField('adrenalina')"
        (change)="resetField('adrenalinaPorcentagem')"
        (change)="resetField('noradrenalina')"
        (change)="resetField('noradrenalinaPorcentagem')"
        (change)="resetField('cloridratoDeFenilefrina')"
        (change)="resetField('cloridratoFenilefrinaPorcentagem')"
        (change)="resetField('porcentagemOutrosAnestesicoVasoConstritor')"
        (change)="resetField('outrosAnestesicoVasoConstritorDesc')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-9" *ngIf="captacao.value.anestesicoVasoConstritor == 'sim'">
      <div class="row">
        <div class="col-4">
          <mat-checkbox
            formControlName="adrenalina"
            (change)="resetField('adrenalinaPorcentagem')"
            [disabled]="termoValido"
            >Adrenalina</mat-checkbox
          >

          <mat-form-field
            *ngIf="captacao.value.adrenalina"
            appearance="standard"
            class="input-full-width"
          >
            <mat-label>Porcentagem</mat-label>
            <input
              matInput
              placeholder="Qual"
              formControlName="adrenalinaPorcentagem"
              id="adrenalinaPorcentagem"
              mask="separator.2"
              thousandSeparator="."
              suffix="%"
            />
          </mat-form-field>
        </div>

        <div class="col-4">
          <mat-checkbox
            formControlName="noradrenalina"
            (change)="resetField('noradrenalinaPorcentagem')"
            [disabled]="termoValido"
            >Noradrenalina</mat-checkbox
          >

          <mat-form-field
            *ngIf="captacao.value.noradrenalina"
            appearance="standard"
            class="input-full-width"
          >
            <mat-label>Porcentagem</mat-label>
            <input
              matInput
              placeholder="Qual"
              formControlName="noradrenalinaPorcentagem"
              id="noradrenalinaPorcentagem"
              mask="separator.2"
              thousandSeparator="."
              suffix="%"
            />
          </mat-form-field>
        </div>

        <div class="col-4">
          <mat-checkbox
            formControlName="cloridratoDeFenilefrina"
            (change)="resetField('cloridratoFenilefrinaPorcentagem')"
            [disabled]="termoValido"
            >Cloridrato de fenilefrina</mat-checkbox
          >
          <mat-form-field
            *ngIf="captacao.value.cloridratoDeFenilefrina"
            appearance="standard"
            class="input-full-width"
          >
            <mat-label>Porcentagem</mat-label>
            <input
              matInput
              placeholder="Qual"
              formControlName="cloridratoFenilefrinaPorcentagem"
              id="cloridratoFenilefrinaPorcentagem"
              mask="separator.2"
              thousandSeparator="."
              suffix="%"
            />
          </mat-form-field>
        </div>

        <div class="col-4">
          <mat-checkbox
            formControlName="outrosAnestesicoVasoConstritor"
            (change)="resetField('porcentagemOutrosAnestesicoVasoConstritor')"
            (change)="resetField('outrosAnestesicoVasoConstritorDesc')"
            [disabled]="termoValido"
            >Outros</mat-checkbox
          >

          <div class="row">
            <div class="col-6">
              <mat-form-field
                *ngIf="captacao.value.outrosAnestesicoVasoConstritor"
                appearance="standard"
                class="input-full-width"
              >
                <mat-label>Qual?</mat-label>
                <input
                  matInput
                  placeholder="Qual"
                  formControlName="outrosAnestesicoVasoConstritorDesc"
                  id="outroBochechos"
                />
              </mat-form-field>
            </div>

            <div class="col-6">
              <mat-form-field
                *ngIf="captacao.value.outrosAnestesicoVasoConstritor"
                appearance="standard"
                class="input-full-width"
              >
                <mat-label>Porcentagem</mat-label>
                <input
                  matInput
                  placeholder="Qual"
                  formControlName="porcentagemOutrosAnestesicoVasoConstritor"
                  id="porcentagemOutrosAnestesicoVasoConstritor"
                  mask="separator.2"
                  thousandSeparator="."
                  suffix="%"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-3">
      <mat-label
        [ngClass]="
          captacao.get('clivagem').hasError('required') ? 'error' : 'ok'
        "
        >Realizou fenda para clivagem?</mat-label
      ><br />
      <mat-radio-group
        formControlName="clivagem"
        (change)="resetField('vestibuloLingual')"
        (change)="resetField('mesioDistal')"
        (change)="resetField('amelocemataria')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-9" *ngIf="captacao.value.clivagem == 'sim'">
      <div class="row">
        <div class="col-4">
          <mat-checkbox
            formControlName="vestibuloLingual"
            [disabled]="termoValido"
            >Vestíbulo-lingual</mat-checkbox
          >
        </div>

        <div class="col-4">
          <mat-checkbox formControlName="mesioDistal" [disabled]="termoValido"
            >Mesio-distal</mat-checkbox
          >
        </div>

        <div class="col-4">
          <mat-checkbox
            formControlName="amelocemataria"
            [disabled]="termoValido"
            >Amelocementária</mat-checkbox
          >
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-7">
      <mat-label
        [ngClass]="
          captacao.get('odontoseccao').hasError('required') ? 'error' : 'ok'
        "
        >Realizou odontosecção para remoção do elemento dentário?</mat-label
      ><br />
      <mat-radio-group
        formControlName="odontoseccao"
        (change)="resetField('desc_Odontoseccao')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-5" *ngIf="captacao.value.odontoseccao == 'sim'">
      <div class="row">
        <div class="col">
          <mat-form-field class="input-full-width mt-1">
            <mat-label>Qual?</mat-label>
            <input
              matInput
              placeholder="Qual?"
              formControlName="desc_Odontoseccao"
              id="desc_Odontoseccao"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-7">
      <mat-label
        [ngClass]="
          captacao.get('remocaoRestauracoes').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Realizou remoção prévia de restaurações?</mat-label
      ><br />
      <mat-radio-group
        formControlName="remocaoRestauracoes"
        (change)="resetField('desc_RemocaoRestauracoes')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="col-5" *ngIf="captacao.value.remocaoRestauracoes == 'sim'">
      <div class="row">
        <div class="col">
          <mat-form-field class="input-full-width mt-1">
            <mat-label>Qual?</mat-label>
            <input
              matInput
              placeholder="Qual?"
              formControlName="desc_RemocaoRestauracoes"
              id="desc_RemocaoRestauracoes"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-7">
      <mat-label
        [ngClass]="
          captacao.get('remocaoCaries').hasError('required') ? 'error' : 'ok'
        "
        >Realizou remoção prévia de cáries?</mat-label
      ><br />
      <mat-radio-group
        formControlName="remocaoCaries"
        (change)="resetField('desc_RemocaoCaries')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-5" *ngIf="captacao.value.remocaoCaries == 'sim'">
      <div class="row">
        <div class="col">
          <mat-form-field class="input-full-width mt-1">
            <mat-label>Qual?</mat-label>
            <input
              matInput
              placeholder="Qual?"
              formControlName="desc_RemocaoCaries"
              id="desc_RemocaoCaries"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Observações - Coleta</mat-label>
        <input
          matInput
          placeholder="Observações - Coleta"
          formControlName="observacoesColeta"
        />
      </mat-form-field>
    </div>
  </div>

  <h3 class="mt-5">Histórico de saúde</h3>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('historiaMedicaSocial1Flag').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Está fazendo algum tratamento médico?</mat-label
      ><br />
      <mat-radio-group
        formControlName="historiaMedicaSocial1Flag"
        (change)="resetField('historiaMedicaSocial1')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>

      <mat-form-field
        appearance="standard"
        class="input-full-width"
        *ngIf="captacao.value.historiaMedicaSocial1Flag == 'sim'"
      >
        <mat-label>Qual?</mat-label>
        <input
          matInput
          placeholder="Qual?"
          formControlName="historiaMedicaSocial1"
          id="historiaMedicaSocial1"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('historiaMedicaSocial2Flag').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Faz uso de algum medicamento?</mat-label
      ><br />
      <mat-radio-group
        formControlName="historiaMedicaSocial2Flag"
        (change)="resetField('historiaMedicaSocial2')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>

      <mat-form-field
        appearance="standard"
        class="input-full-width"
        *ngIf="captacao.value.historiaMedicaSocial2Flag == 'sim'"
      >
        <mat-label>Qual?</mat-label>
        <input
          matInput
          placeholder="Qual?"
          formControlName="historiaMedicaSocial2"
          id="historiaMedicaSocial2"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('historiaMedicaSocial3Flag').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Possui algum tipo de alergia?</mat-label
      ><br />
      <mat-radio-group
        formControlName="historiaMedicaSocial3Flag"
        (change)="resetField('historiaMedicaSocial3')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>

      <mat-form-field
        appearance="standard"
        class="input-full-width"
        *ngIf="captacao.value.historiaMedicaSocial3Flag == 'sim'"
      >
        <mat-label>Qual?</mat-label>
        <input
          matInput
          placeholder="Qual?"
          formControlName="historiaMedicaSocial3"
          id="historiaMedicaSocial3"
        />
      </mat-form-field>
    </div>
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('historiaMedicaSocial4Flag').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Faz algum tratamento complementar?</mat-label
      ><br />
      <mat-radio-group
        formControlName="historiaMedicaSocial4Flag"
        (change)="resetField('historiaMedicaSocial4')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>

      <mat-form-field
        appearance="standard"
        class="input-full-width"
        *ngIf="captacao.value.historiaMedicaSocial4Flag == 'sim'"
      >
        <mat-label>Qual?</mat-label>
        <input
          matInput
          placeholder="Qual?"
          formControlName="historiaMedicaSocial4"
          id="historiaMedicaSocial4"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('historiaMedicaSocial5Flag').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Já realizou alguma intervenção cirúrgica?</mat-label
      ><br />
      <mat-radio-group
        formControlName="historiaMedicaSocial5Flag"
        (change)="resetField('historiaMedicaSocial5')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>

      <mat-form-field
        appearance="standard"
        class="input-full-width"
        *ngIf="captacao.value.historiaMedicaSocial5Flag == 'sim'"
      >
        <mat-label>Qual?</mat-label>
        <input
          matInput
          placeholder="Qual?"
          formControlName="historiaMedicaSocial5"
          id="historiaMedicaSocial5"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('historiaMedicaSocial6Flag').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Já recebeu transfusão de hemocomponentes ou fez uso de algum
        hemoderivado?</mat-label
      ><br />
      <mat-radio-group
        formControlName="historiaMedicaSocial6Flag"
        (change)="resetField('historiaMedicaSocial6')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>

      <mat-form-field
        appearance="standard"
        class="input-full-width"
        *ngIf="captacao.value.historiaMedicaSocial6Flag == 'sim'"
      >
        <mat-label>Qual?</mat-label>
        <input
          matInput
          placeholder="Qual?"
          formControlName="historiaMedicaSocial6"
          id="historiaMedicaSocial6"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('historiaMedicaSocial7Flag').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Já recebeu transfusão de células, tecidos, órgãos ou xenotransplante
        (osso bovino, por exemplo)?</mat-label
      ><br />
      <mat-radio-group
        formControlName="historiaMedicaSocial7Flag"
        (change)="resetField('historiaMedicaSocial7')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>

      <mat-form-field
        appearance="standard"
        class="input-full-width"
        *ngIf="captacao.value.historiaMedicaSocial7Flag == 'sim'"
      >
        <mat-label>Qual?</mat-label>
        <input
          matInput
          placeholder="Qual?"
          formControlName="historiaMedicaSocial7"
          id="historiaMedicaSocial7"
        />
      </mat-form-field>
    </div>
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('historiaMedicaSocial8Flag').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Possui alguma doença hereditária, hematológica ou
        imunológica?</mat-label
      ><br />
      <mat-radio-group
        formControlName="historiaMedicaSocial8Flag"
        (change)="resetField('historiaMedicaSocial8')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>
      <mat-form-field
        appearance="standard"
        class="input-full-width"
        *ngIf="captacao.value.historiaMedicaSocial8Flag == 'sim'"
      >
        <mat-label>Qual?</mat-label>
        <input
          matInput
          placeholder="Qual?"
          formControlName="historiaMedicaSocial8"
          id="historiaMedicaSocial8"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('historiaMedicaSocial9Flag').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Já teve algum tipo de doença maligna?</mat-label
      >
      <br />
      <mat-radio-group
        formControlName="historiaMedicaSocial9Flag"
        (change)="resetField('historiaMedicaSocial9')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>

      <mat-form-field
        appearance="standard"
        class="input-full-width"
        *ngIf="captacao.value.historiaMedicaSocial9Flag == 'sim'"
      >
        <mat-label>Qual?</mat-label>
        <input
          matInput
          placeholder="Qual?"
          formControlName="historiaMedicaSocial9"
          id="historiaMedicaSocial9"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('historiaMedicaSocial10Flag').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Fez viagem recente e/ou teve exposição a agentes
        infecciosos?</mat-label
      >
      <br />
      <mat-radio-group
        formControlName="historiaMedicaSocial10Flag"
        (change)="resetField('historiaMedicaSocial10')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>

      <mat-form-field
        appearance="standard"
        class="input-full-width"
        *ngIf="captacao.value.historiaMedicaSocial10Flag == 'sim'"
      >
        <mat-label>Qual?</mat-label>
        <input
          matInput
          placeholder="Qual?"
          formControlName="historiaMedicaSocial10"
          id="historiaMedicaSocial10"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('historiaMedicaSocial11Flag').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Teve contato com alguém confirmado ou suspeito de covid-19?
      </mat-label>
      <br />
      <mat-radio-group formControlName="historiaMedicaSocial11Flag">
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('historiaMedicaSocial13Flag').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Tomou alguma vacina recentemente?</mat-label
      >
      <br />
      <mat-radio-group
        formControlName="historiaMedicaSocial13Flag"
        (change)="resetField('historiaMedicaSocial13')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>

      <mat-form-field
        appearance="standard"
        class="input-full-width"
        *ngIf="captacao.value.historiaMedicaSocial13Flag == 'sim'"
      >
        <mat-label>Qual(is)? Há quanto tempo? </mat-label>
        <input
          matInput
          placeholder="Qual?"
          formControlName="historiaMedicaSocial13"
          id="historiaMedicaSocial13"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('historiaMedicaSocial12Flag').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Está ou teve algum destes sintomas: Febre, tosse, coriza, dor de
        garganta, dificuldade para respirar, perda de olfato, alteração do
        paladar, cansaço, diminuição do apetite e falta de ar, distúrbios
        gastrointestinais (náusea/vômito/diarreia) ou tem histórico de
        internação por falência respiratória aguda ou pneumonia?</mat-label
      >
      <br />
      <mat-radio-group
        formControlName="historiaMedicaSocial12Flag"
        (change)="resetField('historiaMedicaSocial12')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>

      <mat-form-field
        appearance="standard"
        class="input-full-width"
        *ngIf="captacao.value.historiaMedicaSocial12Flag == 'sim'"
      >
        <mat-label>Qual(is)? Há quanto tempo? </mat-label>
        <input
          matInput
          placeholder="Qual?"
          formControlName="historiaMedicaSocial12"
          id="historiaMedicaSocial12"
        />
      </mat-form-field>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col-sm">
      <mat-label style="color: #808080"
        >Já teve alguma dessas doenças?</mat-label
      ><br />
      <mat-checkbox formControlName="anemia" [disabled]="termoValido"
        >Anemia</mat-checkbox
      ><br />
      <mat-checkbox formControlName="dengue" [disabled]="termoValido"
        >Dengue</mat-checkbox
      ><br />
      <mat-checkbox formControlName="doencaNoFigado" [disabled]="termoValido"
        >Doença no Fígado</mat-checkbox
      ><br />
      <mat-checkbox formControlName="hemorragias" [disabled]="termoValido"
        >Hemorragias</mat-checkbox
      ><br />
      <mat-checkbox formControlName="hemofilia" [disabled]="termoValido"
        >Hemofilia</mat-checkbox
      ><br />
      <mat-checkbox formControlName="leucemia" [disabled]="termoValido"
        >Leucemia</mat-checkbox
      ><br />
      <mat-checkbox formControlName="chikungunya" [disabled]="termoValido"
        >Chikungunya</mat-checkbox
      ><br />
      <mat-checkbox formControlName="febreReumatica" [disabled]="termoValido"
        >Febre Reumática</mat-checkbox
      ><br />

      <mat-checkbox formControlName="hepatite_a" [disabled]="termoValido">
        Hepatite A
      </mat-checkbox>
      <br />
      <mat-checkbox formControlName="hepatite_b" [disabled]="termoValido">
        Hepatite B </mat-checkbox
      ><br />
      <mat-checkbox formControlName="hepatite_c" [disabled]="termoValido"
        >Hepatite C </mat-checkbox
      ><br />
      <mat-checkbox
        formControlName="febre_sem_diagnostico"
        [disabled]="termoValido"
      >
        Febre sem diagnóstico
      </mat-checkbox>
      <br />

      <mat-checkbox formControlName="covid" [disabled]="termoValido"
        >Covid-19</mat-checkbox
      >
    </div>
    <div class="col-sm">
      <br />
      <mat-radio-group>
        <!-- <mat-checkbox formControlName="hepatite" [disabled]="termoValido"
          >Hepatite </mat-checkbox>
          <br /> -->
        <!-- <mat-checkbox formControlName="hepatiteB" [disabled]="termoValido">Hepatite B</mat-checkbox><br>
                    <mat-checkbox formControlName="hepatiteC" [disabled]="termoValido">Hepatite C</mat-checkbox><br> -->
        <mat-checkbox formControlName="tuberculose" [disabled]="termoValido"
          >Tuberculose</mat-checkbox
        ><br />
        <mat-checkbox formControlName="zika" [disabled]="termoValido"
          >Zika</mat-checkbox
        ><br />
        <mat-checkbox formControlName="diabetes" [disabled]="termoValido"
          >Diabetes</mat-checkbox
        ><br />
        <mat-checkbox formControlName="doencaNosRins" [disabled]="termoValido"
          >Doença nos Rins</mat-checkbox
        ><br />
        <!-- <mat-checkbox formControlName="febre">Febre sem diagnóstico</mat-checkbox><br> -->
        <mat-checkbox
          (change)="resetField('outraDoencaSintoma')"
          formControlName="outraDoencaSintomaCheck"
          [disabled]="termoValido"
          >Outra</mat-checkbox
        ><br />
      </mat-radio-group>
      <mat-form-field
        appearance="standard"
        class="input-full-width"
        *ngIf="captacao.value.outraDoencaSintomaCheck"
      >
        <mat-label>Outra</mat-label>
        <input
          matInput
          placeholder="Outra"
          formControlName="outraDoencaSintoma"
        />
      </mat-form-field>
      <br />
      <mat-checkbox
        formControlName="naoDoencaSintomaCheck"
        [disabled]="termoValido"
        >Não</mat-checkbox
      ><br />
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Observações - Histórico de Saúde</mat-label>
        <input
          matInput
          placeholder="Observações - Histórico de Saúde"
          formControlName="observacoesHistoricoSaude"
        />
      </mat-form-field>
    </div>
  </div>

  <h3 class="mt-5">Exame físico</h3>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('exameFisico1Flag').hasError('required') ? 'error' : 'ok'
        "
        >Apresenta lesões na pele ou mucosas?</mat-label
      ><br />
      <mat-radio-group
        formControlName="exameFisico1Flag"
        (change)="resetField('exameFisico1')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>

      <mat-form-field
        appearance="standard"
        class="input-full-width"
        *ngIf="captacao.value.exameFisico1Flag == 'sim'"
      >
        <mat-label>Qual?</mat-label>
        <input
          matInput
          placeholder="Qual?"
          formControlName="exameFisico1"
          id="exameFisico1"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('exameFisico2Flag').hasError('required') ? 'error' : 'ok'
        "
        >Apresenta cicatrizes ou incisões cirúrgicas aparentes?</mat-label
      ><br />
      <mat-radio-group
        formControlName="exameFisico2Flag"
        (change)="resetField('exameFisico2')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>

      <mat-form-field
        appearance="standard"
        class="input-full-width"
        *ngIf="captacao.value.exameFisico2Flag == 'sim'"
      >
        <mat-label>Onde?</mat-label>
        <input
          matInput
          placeholder="Onde?"
          formControlName="exameFisico2"
          id="exameFisico2"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('exameFisico3Flag').hasError('required') ? 'error' : 'ok'
        "
        >Apresenta icterícia?</mat-label
      >
      <br />
      <mat-radio-group formControlName="exameFisico3Flag">
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('exameFisico4Flag').hasError('required') ? 'error' : 'ok'
        "
        >Apresenta hepatomegalia?</mat-label
      >
      <br />
      <mat-radio-group formControlName="exameFisico4Flag">
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-6">
      <mat-label
        [ngClass]="
          captacao.get('exameFisico5Flag').hasError('required') ? 'error' : 'ok'
        "
        >Apresenta linfadenopatia difusa?</mat-label
      ><br />
      <mat-radio-group
        formControlName="exameFisico5Flag"
        (change)="resetField('exameFisico5')"
      >
        <mat-radio-button value="sim">Sim</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="não">Não</mat-radio-button>
      </mat-radio-group>

      <mat-form-field
        appearance="standard"
        class="input-full-width"
        *ngIf="captacao.value.exameFisico5Flag == 'sim'"
      >
        <mat-label>Onde?</mat-label>
        <input
          matInput
          placeholder="Onde?"
          formControlName="exameFisico5"
          id="exameFisico5"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Observações - Exame Físico</mat-label>
        <input
          matInput
          placeholder="Observações - Exame Físico"
          formControlName="observacoesExameFisico"
        />
      </mat-form-field>
    </div>
  </div>

  <h3 class="mt-5">Exames sanguíneos</h3>
  <div class="row">
    <div class="col-sm">
      <mat-form-field>
        <mat-label>Data</mat-label>
        <input
          matInput
          rInputMask="99/99/9999"
          placeholder="dd/mm/aaaa"
          formControlName="dataExamesSanguineos"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field>
        <mat-label>Hemograma</mat-label>
        <mat-select formControlName="hemograma">
          <mat-option value="Normal">Normal</mat-option>
          <mat-option value="Alterado">Alterado</mat-option>
          <mat-option value="Em andamento">Em andamento</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-6">
      <mat-label
        [ngClass]="
          captacao.get('paiFlag').hasError('required') ? 'error' : 'ok'
        "
        >(PAI) - Pesquisa de Anticorpos séricos Irregulares</mat-label
      ><br />
      <mat-radio-group
        formControlName="paiFlag"
        (change)="resetField('descPai')"
      >
        <mat-radio-button value="Realizado">Realizado</mat-radio-button
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não Realizado</mat-radio-button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em andamento</mat-radio-button>
      </mat-radio-group>

      <mat-form-field
        appearance="standard"
        class="input-full-width"
        *ngIf="captacao.value.paiFlag == 'Realizado'"
      >
        <mat-label>Descrição PAI</mat-label>
        <input
          matInput
          placeholder="Descrição PAI"
          formControlName="descPai"
          id="descPai"
        />
      </mat-form-field>
    </div>
  </div>

  <h3 class="mt-5">Resultados sorológicos</h3>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('trypanosoma_1').hasError('required') ? 'error' : 'ok'
        "
        >Trypanosoma cruzi (Chagas) - IgG</mat-label
      >
      <br />
      <mat-radio-group formControlName="trypanosoma_1">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('trypanosoma_2').hasError('required') ? 'error' : 'ok'
        "
        >Trypanosoma cruzi (Chagas) - IgM</mat-label
      >
      <br />
      <mat-radio-group formControlName="trypanosoma_2">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('citomegalovirus_1').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Citomegalovirus - IgG</mat-label
      >
      <br />
      <mat-radio-group formControlName="citomegalovirus_1">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('citomegalovirus_2').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Citomegalovirus - IgM</mat-label
      >
      <br />
      <mat-radio-group formControlName="citomegalovirus_2">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="captacao.get('hiv_1').hasError('required') ? 'error' : 'ok'"
        >HIV Total (HIV I e HIV II)</mat-label
      >
      <br />
      <mat-radio-group formControlName="hiv_1">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="captacao.get('hiv_2').hasError('required') ? 'error' : 'ok'"
        >HIV - Antígeno P24 - PESQUISA E/OU DOSAGEM</mat-label
      >
      <br />
      <mat-radio-group formControlName="hiv_2">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="captacao.get('htlv').hasError('required') ? 'error' : 'ok'"
        >HTLV I e II</mat-label
      >
      <br />
      <mat-radio-group formControlName="htlv">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('hepatiteB_1').hasError('required') ? 'error' : 'ok'
        "
        >Hepatite B - HBsAg</mat-label
      >
      <br />
      <mat-radio-group formControlName="hepatiteB_1">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('hepatiteB_2').hasError('required') ? 'error' : 'ok'
        "
        >Hepatite B - HBcAc-IgM</mat-label
      >
      <br />
      <mat-radio-group formControlName="hepatiteB_2">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('hepatiteB_3').hasError('required') ? 'error' : 'ok'
        "
        >Hepatite B - HBcAc-IgG
      </mat-label>
      <br />
      <mat-radio-group formControlName="hepatiteB_3">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('hepatiteB_4').hasError('required') ? 'error' : 'ok'
        "
        >Hepatite B - HBsAc (anti-HBs)</mat-label
      >
      <br />
      <mat-radio-group formControlName="hepatiteB_4">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('hepatiteC_1').hasError('required') ? 'error' : 'ok'
        "
        >Hepatite C - Anti - HCV</mat-label
      >
      <br />
      <mat-radio-group formControlName="hepatiteC_1">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('treponemaPallidum_1').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Treponema pallidum (sífilis) - FTA-ABS-IgG</mat-label
      >
      <br />
      <mat-radio-group formControlName="treponemaPallidum_1">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('treponemaPallidum_2').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Treponema pallidum (sífilis) - FTA-ABS-IgM</mat-label
      >
      <br />
      <mat-radio-group formControlName="treponemaPallidum_2">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('sifilisvdrl').hasError('required') ? 'error' : 'ok'
        "
        >Sífilis - VDRL</mat-label
      >
      <br />
      <mat-radio-group formControlName="sifilisvdrl">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('toxoplasmaGondii_1').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Toxoplasma gondii (toxoplasmose) - IgG</mat-label
      >
      <br />
      <mat-radio-group formControlName="toxoplasmaGondii_1">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('toxoplasmaGondii_2').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Toxoplasma gondii (toxoplasmose) - IgM</mat-label
      >
      <br />
      <mat-radio-group formControlName="toxoplasmaGondii_2">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('malaria_1').hasError('required') ? 'error' : 'ok'
        "
        >Malária - IgG</mat-label
      >
      <br />
      <mat-radio-group formControlName="malaria_1">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('malaria_2').hasError('required') ? 'error' : 'ok'
        "
        >Malária - IgM</mat-label
      >
      <br />
      <mat-radio-group formControlName="malaria_2">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('sARS_CoV2_Covid_19_igg').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Sorologia para SARS-CoV2/Covid-19 (IgG)</mat-label
      >
      <br />
      <mat-radio-group formControlName="sARS_CoV2_Covid_19_igg">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('sARS_CoV2_Covid_19_igm').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Sorologia para SARS-CoV2/Covid-19 (IgM)</mat-label
      >
      <br />
      <mat-radio-group formControlName="sARS_CoV2_Covid_19_igm">
        <mat-radio-button value="Reagente">Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não reagente">Não Reagente</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Inconclusivo">Inconclusivo</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('sARS_CoV2_Covid_19_igm').hasError('required')
            ? 'error'
            : 'ok'
        "
        >SARS-CoV2/Covid-19 (PCR)</mat-label
      >
      <br />
      <mat-radio-group formControlName="sARS_CoV2_Covid_pcr">
        <mat-radio-button value="Positivo">Positivo</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Negativo">Negativo</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('pcrqualitativocmv').hasError('required')
            ? 'error'
            : 'ok'
        "
        >PCR Qualitativo para CMV</mat-label
      >
      <br />
      <mat-radio-group formControlName="pcrqualitativocmv">
        <mat-radio-button value="Positivo">Positivo</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Negativo">Negativo</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('pcrquantitativohepatiteb').hasError('required')
            ? 'error'
            : 'ok'
        "
        >PCR Quantitativo para Hepatite B</mat-label
      >
      <br />
      <mat-radio-group formControlName="pcrquantitativohepatiteb">
        <mat-radio-button value="Positivo">Positivo</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Negativo">Negativo</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('pcrqualitativohepatitec').hasError('required')
            ? 'error'
            : 'ok'
        "
        >PCR Qualitativo para Hepatite C</mat-label
      >
      <br />
      <mat-radio-group formControlName="pcrqualitativohepatitec">
        <mat-radio-button value="Positivo">Positivo</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Negativo">Negativo</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('pcrqualitativohiv').hasError('required')
            ? 'error'
            : 'ok'
        "
        >PCR Qualitativo para HIV</mat-label
      >
      <br />
      <mat-radio-group formControlName="pcrqualitativohiv">
        <mat-radio-button value="Positivo">Positivo</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Negativo">Negativo</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('pcrhtlv1').hasError('required') ? 'error' : 'ok'
        "
        >PCR para HTLV I</mat-label
      >
      <br />
      <mat-radio-group formControlName="pcrhtlv1">
        <mat-radio-button value="Positivo">Positivo</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Negativo">Negativo</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('pcrhtlv2').hasError('required') ? 'error' : 'ok'
        "
        >PCR para HTLV II</mat-label
      >
      <br />
      <mat-radio-group formControlName="pcrhtlv2">
        <mat-radio-button value="Positivo">Positivo</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Negativo">Negativo</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('pcrqualitativoepsteinbarr').hasError('required')
            ? 'error'
            : 'ok'
        "
        >PCR Qualitativo para Epstein Barr</mat-label
      >
      <br />
      <mat-radio-group formControlName="pcrqualitativoepsteinbarr">
        <mat-radio-button value="Positivo">Positivo</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Negativo">Negativo</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Em andamento">Em Andamento</mat-radio-button
        >&nbsp;&nbsp;
        <mat-radio-button value="Não realizado">Não realizado</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('examesadicionais').hasError('required') ? 'error' : 'ok'
        "
        >Solicitados exames adicionais?</mat-label
      >
      <br />
      <mat-radio-group formControlName="examesadicionais">
        <mat-radio-button value="Sim">Sim</mat-radio-button>&nbsp;&nbsp;
        <mat-radio-button value="Não">Não</mat-radio-button>&nbsp;&nbsp;
      </mat-radio-group>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Observações - Dados Laboratoriais</mat-label>
        <input
          matInput
          placeholder="Observações - Dados Laboratoriais"
          formControlName="observacoesDadosLaboratoriais"
        />
      </mat-form-field>
    </div>
  </div>
</form>

<div class="row">
  <div class="col-12">
    <h3 [class.error]="captacaoTecidosCaptados.length < 1" class="mt-5">
      Tecidos coletados
    </h3>

    <mat-card>
      <mat-card-title>
        <div class="row">
          <!-- <div class="col p-3">
                            Tecidos Coletados
                        </div> -->
          <div class="pt-2 pl-3 text-right">
            <button
              *ngIf="!termoValido; none"
              (click)="addTecidos()"
              mat-mini-fab
              style="background-color: green"
            >
              <mat-icon>add</mat-icon>
            </button>

            <!-- <mat-icon class="tecido" *ngIf="!finalizarEdColeta; none" (click)="addTecidos()" class="pointer">add_circle</mat-icon> -->
          </div>
        </div>
      </mat-card-title>

      <mat-card-content>
        <mat-list role="list" *ngIf="store.relacionado">
          <div class="row">
            <!-- <strong class="col-4">Código</strong> -->
            <strong class="col-3 text-start">Grupo</strong>
            <strong class="col-3 text-center">Sítio</strong>
            <strong class="col-3 text-center">Tecido</strong>
            <strong class="col-3 text-right" *ngIf="!termoValido; none"
              >Remover</strong
            >
          </div>

          <div *ngFor="let tecidoCaptado of captacaoTecidosCaptados">
            <div
              *ngIf="
                tecidoCaptado.acao != 'Remover' && tecidoCaptado.codigo != null
              "
              class="d-flex mt-5"
            >
              <div class="mr-auto mt-1 col-3 pl-0">
                <p>{{ tecidoCaptado.grupo }}</p>
              </div>

              <div class="mr-auto mt-1 col-3 text-center">
                <p>{{ tecidoCaptado.sitio }}</p>
              </div>

              <div class="mr-auto mt-1 col-3 ml-1 text-center">
                <p>{{ tecidoCaptado.nome }}</p>
              </div>

              <div
                *ngIf="tecidoCaptado.codigo !== null"
                class="tecido col-3 text-right"
              >
                <div
                  *ngIf="!termoValido; none"
                  (click)="excluirTecidoCaptado(tecidoCaptado)"
                >
                  <mat-icon>delete</mat-icon>
                </div>
              </div>
            </div>
          </div>
        </mat-list>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<form [formGroup]="captacao" class="pt-3" class="mb-5">
  <h3 class="mt-5">Destino dos tecidos (Ética)</h3>

  <div class="row">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('destinoTecidosDuros').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Estou ciente de que quando da presença de Tecidos Dentários Duros
        (esmalte e dentina) onde não há a presença de células-tronco, manifesto
        que estes tecidos duros devem ser:</mat-label
      ><br />
      <mat-radio-group
        formControlName="destinoTecidosDuros"
        (change)="validaDoador()"
      >
        <mat-radio-button value="2">{{ tecidoDuroDescartado }}</mat-radio-button
        ><br />
        <mat-radio-button value="1">{{ tecidoDuroDoado }}</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('destinoMaterialBiologico').hasError('required')
            ? 'error'
            : 'ok'
        "
        >Estou ciente que no momento da coleta devo indicar a destinação do
        material biológico quando da não continuidade do contrato, inclusive em
        caso de morte do beneficiário e/ou da desistência de manutenção do
        pagamento pelo armazenamento do material biológico, inclusive células,
        seus produtos e DNA do doador, portanto, manifesto que o material deve
        ser:</mat-label
      ><br />
      <mat-radio-group
        formControlName="destinoMaterialBiologico"
        (change)="validaDoador()"
      >
        <mat-radio-button value="2">{{
          destinoMaterialDescartado
        }}</mat-radio-button
        ><br />
        <mat-radio-button value="1">{{
          destinoMaterialDoado
        }}</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-sm">
      <mat-label
        [ngClass]="
          captacao.get('doacaoPesquisa').hasError('required') ? 'error' : 'ok'
        "
        >Em caso de doação para pesquisa também devo informar se:</mat-label
      ><br />
      <mat-radio-group formControlName="doacaoPesquisa">
        <mat-radio-button value="1">{{ doacaoPesquisaSim }}</mat-radio-button
        ><br />
        <mat-radio-button value="2">{{ doacaoPesquisaNao }}</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
</form>
